import {TGradientStyles} from 'components/CircledProgressBar';
import {IMenuItem, TCodeKeys} from 'modules/user/types';
import {
    DASHBOARD_PROFILE_ADDRESS_ROUTE,
    DASHBOARD_PROFILE_ROUTE,
    DASHBOARD_PROFILE_SOCIAL_ROUTE,
    LOGOUT_ROUTE,
} from 'core/modules/routing/constants';

export const PROFILE_USER_MENU_LIST: IMenuItem[] = [
    {
        icon: 'profile',
        shallow: true,
        text: 'Личные данные',
        url: DASHBOARD_PROFILE_ROUTE,
    },
    {
        icon: 'placemark-m',
        shallow: true,
        text: 'Адреса доставки',
        url: DASHBOARD_PROFILE_ADDRESS_ROUTE,
    },
    {
        icon: 'social-networks-attach',
        shallow: true,
        text: 'Привязанные соцсети',
        url: DASHBOARD_PROFILE_SOCIAL_ROUTE,
    },
    {
        icon: 'Exit',
        shallow: true,
        text: 'Выйти из профиля',
        url: LOGOUT_ROUTE,
    },
];

export const GRADIENT_STYLES: {
    [key in TCodeKeys]: TGradientStyles;
} = {
    aromaticity: {
        fromColor: '#70ff00',
        id: 'gradient-acidity_aromaticity',
        toColor: '#7cffde',
    },
    body: {
        fromColor: '#e61640',
        id: 'gradient-acidity_all_body',
        toColor: '#af3cc9',
    },
    sourness: {
        fromColor: '#ff027d',
        id: 'gradient-acidity_all_sourness',
        toColor: '#ffc000',
    },
    sweetness: {
        fromColor: '#ff43b6',
        id: 'gradient-acidity_all_sweetness',
        toColor: '#ff6859',
    },
};

export const SOCIAL_LINKS = [
    {icon: 'telegram-xl', path: '/'},
    // {icon: 'whats-app-xl', path: '/'},
    {icon: 'vk-xl', path: '/'},
    {icon: 'classmates-xl', path: '/'},
] as const;

export const USER_GROUPS_CODE = {
    employee: [8, 9, 10, 11],
    // PRIVE
    prive: [40, 41, 42, 43],
    // ECOM
    ecom: [50, 51, 52],
};
